var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoSnack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fastfood_black_24dp 2",
    clipPath: "url(#clip0_4091_14894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.29199 28.3907C1.29199 29.114 1.87324 29.6953 2.59658 29.6953H19.3753C20.0987 29.6953 20.6799 29.114 20.6799 28.3907V27.1248H1.29199V28.3907ZM10.9795 11.6119C6.13574 11.6119 1.29199 14.2082 1.29199 19.3748H20.667C20.667 14.2082 15.8232 11.6119 10.9795 11.6119ZM4.67616 16.7915C6.10991 14.7894 9.15824 14.1953 10.9795 14.1953C12.8007 14.1953 15.8491 14.7894 17.2828 16.7915H4.67616ZM1.29199 21.9582H20.667V24.5415H1.29199V21.9582ZM23.2503 6.45817V1.2915H20.667V6.45817H14.2087L14.5057 9.0415H26.8541L25.0457 27.1248H23.2503V29.7082H25.472C26.557 29.7082 27.4482 28.8686 27.5774 27.8094L29.7087 6.45817H23.2503Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4091_14894"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSnack);
export default __webpack_public_path__ + "static/media/no-snack.28edb61c0f940e788797c20dfcef2c22.svg";
export { ForwardRef as ReactComponent };